module.exports = __webpack_public_path__ + "img/pentagon-fill.0d3a4702.svg";